import { IWarning } from 'redux-state/weather-warnings/types.js';
import { IMarker } from 'types/markerCore/marker-core-type.js';
import { getFirstOfArr, predicateMarkerV1 } from 'utilities/isType.js';
import { getCentreOfPolygon, getPolygon2D } from 'utilities/polygons/utils.js';
import { ILocationSummary } from '../markerTypesV1/marker-v1-view-type.js';
import { MarkerTypeCodeGenerated, MarkerTypeGeneral } from './location-markers-type.js';

export type WarningLocationType = {
  type: MarkerTypeCodeGenerated.Warning;
  value: {
    warning: IWarning[];
  };
};

export const getWarningPolygons = (warning: Pick<IWarning, 'polygons' | 'polygon'>) => {
  const twodPolygons = getPolygon2D(warning.polygons) ?? [];
  const polygons = warning.polygon ? twodPolygons?.concat([warning.polygon]) : twodPolygons;
  /** These show a marker icon in center of polygon
   * We don't want these on marine as they are shown as regions, only warnings and watches page
   */
  const points = polygons.map(getCentreOfPolygon);
  return { points, polygons };
};

export const getMarkerWarnings = (marker: IMarker): IWarning[] => {
  if (predicateMarkerV1(marker)) {
    const subjectItem = getFirstOfArr(marker.subject);
    if (subjectItem) {
      return getMarkerWarningsLoc(subjectItem);
    }
    return [];
  }
  if (marker?.generatedWarningsList) {
    return marker?.generatedWarningsList;
  }
  return [];
};

export const getMarkerWarningsLoc = (subjectItem: ILocationSummary): IWarning[] => {
  if (subjectItem) {
    if (subjectItem?.type === MarkerTypeGeneral.HighSeas) {
      const value = subjectItem.value.highSeasWarnings;
      return value;
    }
    const value = ('warning' in subjectItem.value ? subjectItem.value.warning : []) ?? [];
    return value;
  }

  return [];
};
